
export const userSelector = state => state.userStore;
export const authSelector = state => state.authStore;
